<ion-content [scrollEvents]="true">
  <ion-header class="main-header" mode="ios">
        <ion-icon  slot="start" name="chevron-back-outline"  (click)="goBack()" ></ion-icon>
  
    <div class="icon-container">
      <ion-icon 
        class="heart" 
        src="assets/imgs/custom-svg/like_heart.svg" 
        style="font-size: 30px;">
      </ion-icon>
    </div>
  
    <div class="ghost"> </div>
  </ion-header>
  
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="info-modal">
    <p class="likes-label centered-content">
      {{ 'likedUsers' | translate }}
    </p>
    
    <!--Quantity Label-->
    <!--Display NewLikes-->
    <p *ngIf="newLikes > 1" class="you-got-label centered-content">
      {{ 'totalNewLikesMessage' | translate: { quantity: newLikes } }}
    </p>

    <p *ngIf="newLikes === 1" class="you-got-label centered-content">
      {{ 'oneNewLikeMessage' | translate }}
    </p>
  </div>  

  <div class="be-avocado" *ngIf="!canSeeWhoLikedMe && likedBySouls?.length">
    <ion-button class="reveal-button" shape="round" color="primary" (click)="openStore()">
      <ion-icon name="eye" slot="start"></ion-icon>
      {{ 'reveal' | translate }}
    </ion-button> 
  </div>

  <!-- Blurred Likes -->
  <div class="grid-template" *ngIf="!canSeeWhoLikedMe">
    <ng-container *ngFor="let soul of likedBySouls; let i = index">
      <div class="wrapper">
        <div class="tag-novo" *ngIf="i < newLikes">{{ 'new' | translate }}</div>
        <div class="pic-container">
          <app-loading-spinner [click]= "openStore.bind(this)" [customStyle]="{ 'filter': 'blur(13px)'}" [index] = "0" [image] ="soul.thePicture?.$oid ? userService.getImageURL(soul.thePicture.$oid) : ''"></app-loading-spinner>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Visible Likes -->
  <div class="grid-template" *ngIf="canSeeWhoLikedMe">
    <ng-container *ngFor="let soul of likedBySouls; let i = index">
      <div class="profile">
        <div class="wrapper">
          <div class="tag-novo" *ngIf="i < newLikes">{{ 'new' | translate }}</div>
          <div class="pic-container">
            <app-loading-spinner [click]= "openProfile.bind(this)" [index] = "soul" [image] ="userService.getImageURL(getFirstAvailablePicture(soul))"></app-loading-spinner>
          </div>
          <img *ngIf="soul.userValidated"  class="verified" src="assets/imgs/new-check-img.svg">
        </div>

        <p class="name">
          <span class="name-text">{{soul.firstName}}</span>
          <span class="age-text">, {{soul.age}}</span>
        </p>
        
      </div>
    </ng-container>
  </div>

  <div class = "centered-content" *ngIf="isLoading">
    <div class="loader"></div>
  </div>

  <!--Empty Likes-->
  <div class="empty" *ngIf="!likedBySouls?.length && !isLoading">
    <p class="nothing">{{ 'nothingHere' | translate }}</p>
    <p class="suggestion">{{ 'improveProfile' | translate }}</p>

    <div class="button-div">
      <ion-button mode= "md" size="small" shape="round" fill="outline" (click)="goToProfilePage()">
        {{ 'completeProfile' | translate }}
      </ion-button>
      <ion-button class="orange-button" mode= "md" size="small" shape="round" fill="outline" (click)="vegBoostEnable ? openActiveVegBoost() : openModalVegBoost()">
        {{ 'vegboost' | translate }}
      </ion-button>
    </div>
  </div>

  <!--Scroll Top Floating Button-->
  <ion-fab *ngIf="showScrollButton" slot="fixed" vertical="top" horizontal="end" (click)="refreshPositionInfo()"
    alt="Veggie Boost">
    <ion-fab-button size="small" color="primary">
      <ion-icon style="font-size: 27px;" name="chevron-up-circle-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>

</ion-content>